import { Component } from '@angular/core';
import { SearchableEntityServiceFactory } from '../../../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { NavigationService } from '../../../../../core/navigation.service';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { DetailedEntityDataEditorService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { DetailedEntityBackendService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-backend.service';
import { MaintainReportButtonService } from '../../services/maintain-report-button.service';
import { MaintainReportDataService } from '../../services/maintain-report-data.service';
import { DetailedEntityActionService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-action.service';

@Component({
    selector: 'lfwms-maintain-report-details',
    templateUrl: './maintain-report-details.component.html',
    styleUrls: ['./maintain-report-details.component.css'],
})
export class MaintainReportDetailsComponent {

    public serviceFactory: SearchableEntityServiceFactory;

    constructor(protected dataService: MaintainReportDataService,
            protected navService: NavigationService,
            protected actionService: DetailedEntityActionService,
            protected buttonService: MaintainReportButtonService,
            protected dataEditor: DetailedEntityDataEditorService,
            protected backendService: DetailedEntityBackendService,
            protected sharedServiceRegistry: SharedServiceRegistry) {
        this.serviceFactory = new SearchableEntityServiceFactory(dataService,
            actionService, backendService, dataEditor, buttonService);
    }

}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component.ts